export enum MilestoneCardAction {
  NOT_READY,
  READY,
  COMPLETED,
}
